import React from "react";
import { observer } from "mobx-react";
import { AuthorCollectingSocietyUpdateStore } from "../../store";
import { AuthorCollectingSocietyUpdateForm } from "./AuthorCollectingSocietyUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type AuthorCollectingSocietyUpdateProps = {
  authorCollectingSocietyUpdateStore: AuthorCollectingSocietyUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AuthorCollectingSocietyUpdate: React.FC<AuthorCollectingSocietyUpdateProps> =
  observer(
    ({
      authorCollectingSocietyUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={authorCollectingSocietyUpdateStore.isSaving} />
          <AuthorCollectingSocietyUpdateForm
            authorCollectingSocietyUpdateStore={
              authorCollectingSocietyUpdateStore
            }
            collectingSocietyError={
              authorCollectingSocietyUpdateStore.errors.collectingSociety
                ?.message
            }
            onCollectingSocietyChange={(value) => {
              authorCollectingSocietyUpdateStore.setCollectingSocietyValue(
                value
              );
            }}
            collectingSocietySelectedValue={
              authorCollectingSocietyUpdateStore.entityValues
                .showCollectingSociety
            }
            onCollectingSocietySelected={(value) => {
              authorCollectingSocietyUpdateStore.setSelectedCollectingSociety(
                value
              );
            }}
            collectingSocietyOptions={authorCollectingSocietyUpdateStore.getCollectingSocietyOptions()}
            memberNumberError={
              authorCollectingSocietyUpdateStore.errors.memberNumber?.message
            }
            onMemberNumberChange={(value: string) => {
              authorCollectingSocietyUpdateStore.setMemberNumberValue(value);
            }}
            memberNumber={
              authorCollectingSocietyUpdateStore.entityValues.memberNumber
            }
            territoriesError={
              authorCollectingSocietyUpdateStore.errors.territories?.message
            }
            onTerritoriesChange={(value) => {
              authorCollectingSocietyUpdateStore.setTerritoriesValue(value);
            }}
            territoriesSelectedValues={
              authorCollectingSocietyUpdateStore.entityValues.showTerritories
            }
            onTerritoriesSelected={(value) => {
              authorCollectingSocietyUpdateStore.setSelectedTerritories(value);
            }}
            territoriesOptions={authorCollectingSocietyUpdateStore.getTerritoriesOptions()}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={authorCollectingSocietyUpdateStore.saveDisabled}
            onSave={() =>
              authorCollectingSocietyUpdateStore.saveAuthorCollectingSociety()
            }
            onCancel={() =>
              authorCollectingSocietyUpdateStore.cancelAuthorCollectingSociety()
            }
          />
          <ErrorDialog
            open={authorCollectingSocietyUpdateStore.errorDialogOpened}
            title={authorCollectingSocietyUpdateStore.errorTitle}
            description={authorCollectingSocietyUpdateStore.errorDescription}
            onClose={() =>
              authorCollectingSocietyUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={authorCollectingSocietyUpdateStore.confirmDialogOpened}
            title={authorCollectingSocietyUpdateStore.confirmDialogTitle}
            description={
              authorCollectingSocietyUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              authorCollectingSocietyUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              authorCollectingSocietyUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
